import { Platform } from "react-native";

export const goBack = (navigation: any) => {
    if (Platform.OS === 'web') {
        window.history.back();
        return;
    }
    navigation.goBack();
}